import esEs from 'antd/es/locale/es_ES';

const { Table, Pagination, Form, Empty } = esEs;

export const locale = {
  ...esEs,
  Table: {
    ...Table,
    triggerAsc: 'Ordenar ascendentemente',
    triggerDesc: 'Ordenar descendentemente',
    cancelSort: 'Restablecer orden',
  },
  Pagination: {
    ...Pagination,
    items_per_page: 'por página',
  },
  Form: {
    ...Form,
    defaultValidateMessages: {
      ...Form.defaultValidateMessages,
      required: 'Este campo es obligatorio',
      whitespace: 'Este campo no debe contener solo espacios en blanco',
      types: {
        ...Form.defaultValidateMessages.types,
        email: 'El formato del correo electrónico no es válido',
      },
    },
  },
  Empty: {
    ...Empty,
    description: 'No hay información disponible',
  },
};